import { styled } from '@mui/material';

export const Svg = styled('svg')({});
